import Banner from 'components/Banner';

import useTranslation from './hooks/useTranslation';

import {
    CONCENTRATION_DECIMAL_PRECISION,
    CONCENTRATION_WARN_THRESHOLD_PCT,
    DRONE_GPA_THRESHOLD,
    GPA_DECIMAL_PRECISION,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LowGpaConcentrationWarning: FunctionComponent<Props> = ({
    carrierRateGalPerAc,
    className = '',
    productConcentrationPct,
    testId = TEST_ID
}) => {
    const { description } = useTranslation();
    const shouldWarn =
        carrierRateGalPerAc > 0 &&
        carrierRateGalPerAc <= DRONE_GPA_THRESHOLD &&
        productConcentrationPct >= CONCENTRATION_WARN_THRESHOLD_PCT;

    if (!shouldWarn) {
        return null;
    }

    const text = description(
        carrierRateGalPerAc.toFixed(GPA_DECIMAL_PRECISION),
        productConcentrationPct.toFixed(CONCENTRATION_DECIMAL_PRECISION)
    );

    return (
        <Banner
            className={`${styles.lowGpaConcentrationWarning} ${className}`}
            icon='info'
            testId={testId}
            text={text}
            variant='info'
        />
    );
};

export default LowGpaConcentrationWarning;
